// Think of MessageTypes as actions within a MessageGroup -> MessageArea
// eg. Contact -> InMails -> InMailSend

export enum LiveBiddingStatusEnum {
  Paused,
  Live,
  Ended
}
